import create from 'zustand';
import produce from 'immer';

const WEBINAR_EDIT_INITIAL = {
	webinar: {
		title: '',
		url: '',
		eventAt: '',
		type: '',
		status: '',
		subjectId: 0,
		courseId: 0
	}
};

export const useWebinarEditStore = create(set => ({
	...WEBINAR_EDIT_INITIAL,

	// Handle state change
	onChange: ({ name, value }) => set(produce(state => {
		state.webinar[name] = value;
	})),

	// Initialize webinar's state
	onInit: (webinar) => set({
		webinar: {
			title: webinar.title,
			url: webinar.url,
			eventAt: webinar.eventAt,
			type: webinar.type,
			status: webinar.status,
			subjectId: webinar.subjectId,
			courseId: webinar.courseId,
		}
	}),

	// Reset store to initial state
	onReset: () => set({
		...WEBINAR_EDIT_INITIAL
	})
}));